
import { ButtonHTMLAttributes, ReactNode } from 'react';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  children: ReactNode;
  className?: string;
}

export default function Button({ 
  variant = 'primary', 
  size = 'md', 
  children, 
  className = '', 
  ...props 
}: ButtonProps) {
  const baseClasses = 'inline-flex items-center justify-center font-medium transition-all duration-300 cursor-pointer whitespace-nowrap';
  
  const variants = {
    primary: 'bg-cyan-500 hover:bg-cyan-400 text-black border border-cyan-500 hover:border-cyan-400 hover:shadow-lg hover:shadow-cyan-500/25',
    secondary: 'bg-transparent hover:bg-gray-800 text-cyan-400 border border-cyan-500 hover:border-cyan-400 hover:shadow-lg hover:shadow-cyan-500/25',
    ghost: 'bg-transparent hover:bg-gray-800/50 text-gray-300 hover:text-cyan-400 border border-transparent hover:border-cyan-500/30'
  };
  
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg'
  };
  
  return (
    <button 
      className={`${baseClasses} ${variants[variant]} ${sizes[size]} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
}
